const FOCUSABLE_SELECTORS = 'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.section-mystery-hero-banner');
  if (!banner) return;

  const modal = banner.querySelector('[data-mystery-modal]');
  const openBtn = banner.querySelector('[data-mystery-open-modal]');
  const bottomContainer = banner.querySelector('.mystery-banner-bottom');
  const defaultBtnText = openBtn?.textContent.trim() || 'BUY MYSTERY BOX';
  const atcBtnText = 'ADD TO CART';
  let selectedVariantId = null;
  let visibilityLocked = false;

  const openModal = () => {
    modal.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    bottomContainer.classList.add('mystery-banner-bottom--open');
    modal.querySelector(FOCUSABLE_SELECTORS)?.focus();
  };

  const closeModal = () => {
    modal.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    bottomContainer.classList.remove('mystery-banner-bottom--open');
    selectedVariantId = null;
    for (const b of banner.querySelectorAll('[data-mystery-variant]')) {
      b.classList.remove('mystery-size-modal-size-btn--selected');
    }
    openBtn.textContent = defaultBtnText;
    openBtn.focus();
  };

  const selectVariant = (btn) => {
    for (const b of banner.querySelectorAll('[data-mystery-variant]')) {
      b.classList.remove('mystery-size-modal-size-btn--selected');
    }
    btn.classList.add('mystery-size-modal-size-btn--selected');
    selectedVariantId = btn.dataset.mysteryVariant;
    openBtn.textContent = atcBtnText;
  };

  const addToCart = async () => {
    if (!selectedVariantId) return;

    openBtn.disabled = true;
    openBtn.classList.add('is-loading');
    openBtn.classList.remove('is-error');
    openBtn.innerHTML = '<span class="mystery-btn-spinner"></span>';

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer?.getSectionsToRender().map((s) => s.id) ?? ['cart-drawer', 'cart-icon-bubble'];

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: Number(selectedVariantId),
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error(`Cart error: ${response.status}`);

      const data = await response.json();
      closeModal();
      visibilityLocked = true;
      bottomContainer.dataset.visible = 'true';
      setTimeout(() => { visibilityLocked = false; }, 500);

      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
      }
    } catch (error) {
      console.error('Mystery box add to cart failed:', error);
      openBtn.classList.add('is-error');
    } finally {
      openBtn.disabled = false;
      openBtn.classList.remove('is-loading');
      openBtn.textContent = defaultBtnText;
    }
  };

  const trapFocus = (event) => {
    const focusable = [...modal.querySelectorAll(FOCUSABLE_SELECTORS)];
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  /* Sticky behavior: always visible, hides when footer is reached on desktop */
  const footer = document.querySelector('#shopify-section-footer') || document.querySelector('footer') || document.querySelector('.footer');
  const updateVisibility = () => {
    if (visibilityLocked) return;
    if (window.innerWidth >= 750 && footer) {
      const footerTop = footer.getBoundingClientRect().top;
      const btnHeight = bottomContainer.offsetHeight;
      bottomContainer.dataset.visible = footerTop <= window.innerHeight + btnHeight ? 'false' : 'true';
      return;
    }
    const scrollPercent = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
    bottomContainer.dataset.visible = scrollPercent >= 94 ? 'false' : 'true';
  };

  window.addEventListener('scroll', updateVisibility, { passive: true });
  bottomContainer.dataset.visible = 'true';

  banner.addEventListener('click', (event) => {
    if (event.target.closest('[data-mystery-open-modal]')) {
      if (modal.hidden) {
        openModal();
      } else {
        addToCart();
      }
      return;
    }
    if (event.target.closest('[data-mystery-close]')) {
      closeModal();
      return;
    }
    const variantBtn = event.target.closest('[data-mystery-variant]');
    if (variantBtn) {
      selectVariant(variantBtn);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') {
      closeModal();
      return;
    }
    if (event.key === 'Tab') {
      trapFocus(event);
    }
  });
});
